import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/ticketco-tickets/ticketco-tickets/layouts/default.vue").then(m => m.default || m)),
  "one-column-layout": defineAsyncComponent(() => import("/home/runner/work/ticketco-tickets/ticketco-tickets/layouts/oneColumnLayout.vue").then(m => m.default || m)),
  "two-column-layout": defineAsyncComponent(() => import("/home/runner/work/ticketco-tickets/ticketco-tickets/layouts/twoColumnLayout.vue").then(m => m.default || m))
}